import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) =>
    state.salesDemoState || initialState;

export const selectMetrics = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.metrics,
);

export const selectMockApiFlag = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.mockApiFlag,
);
export const selectMysqlFlag = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.mysqlFlag,
);

export const selectExcludeMysqlParams = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.excludeMysqlParams,
);

export const selectTimeperiod = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.timeperiod,
);

export const selectDataGridData = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.dataGridData,
);

export const selectNurturingHistory = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.nurturingHistory,
);

export const selectTaskHtml = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.taskHtml,
);

export const selectExportData = createSelector(
    [selectDomain],
    salesDemoState => salesDemoState.exportData,
);